import { Injectable } from '@angular/core';
import { Mutation, Query, gql } from 'apollo-angular';
import { LandingPageFormInput } from '../components/home-page/contact-us.model';

@Injectable({
  providedIn: 'root',
})
export class ContactUsFormService extends Mutation<LandingPageFormInput> {
  document = gql`
    mutation CreateLandingPageForm($input: LandingPageFormInput!) {
      createLandingPageForm(createLandingFormInput: $input) {
        _id
        createdAt
        updatedAt
        subject
        companyName
        contactName
        email
        phone
        message
      }
    }
  `;
}
